<template>
  <div id="notifications" v-if="hasNotifications">
    <div class="alert alert-danger" id="notification_connection" v-if="notificationConnection">
      <h4 class="alert-heading">Connection lost!</h4>
      <p>Attempting to restore connection. Changes made now are not saved.</p>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'notifications',
    computed: {
      hasNotifications () {
        return this.notificationConnection
      },
      notificationConnection () {
        return !this.$store.getters.connected
      }
    }
  }
</script>

<style lang="scss" scoped>
  #notifications {
    position: fixed;
    right: 5px;
    top: 60px;
    z-index: 1111111;
    max-width: 270px;

    > div {
      box-shadow: 0 20px 32px -8px rgba(9, 45, 66, .25);
    }
  }
</style>



// WEBPACK FOOTER //
// src/layout/notifications.vue